import React, { useState, useEffect, useCallback, memo } from "react";
import { Dropdown, Option } from "@fluentui/react-components";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const regions = [
  { id: "EU", label: "Europe (EU)" },
  { id: "AMER", label: "Americas (AMER)" },
  { id: "APAC", label: "Asia-Pacific (APAC)" },
];

function RegionSelector({ value, onSelect, disabled }) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState("");

  // ✅ Keep local state in sync with external value (for edit mode)
  useEffect(() => {
    if (value && value !== selected) {
      setSelected(value);
    }
  }, [value, selected]);

  // ✅ Stable callback + async-safe to avoid ResizeObserver warnings
  const handleChange = useCallback(
    (_, data) => {
      const regionId = data.optionValue;
      setSelected(regionId);
      if (onSelect) {
        setTimeout(() => onSelect(regionId), 0); // let Dropdown finish closing first
      }
    },
    [onSelect]
  );

  // Trouver le label de la région sélectionnée
  const selectedRegion = regions.find(r => r.id === selected);
  const displayValue = selectedRegion ? selectedRegion.label : "";

  return (
    <Dropdown
      placeholder={t("SELECT_REGION")}
      value={displayValue}
      selectedOptions={selected ? [selected] : []}
      onOptionSelect={handleChange}
      appearance="outline"
      disabled={disabled}
      style={{ width: "100%" }}
    >
      {regions.map((region) => (
        <Option key={region.id} value={region.id}>
          {region.label}
        </Option>
      ))}
    </Dropdown>
  );
}

RegionSelector.propTypes = {
  value: PropTypes.string,
  onSelect: PropTypes.func,
  disabled: PropTypes.bool,
};

// ✅ Prevent re-render unless the region value actually changes
export default memo(RegionSelector, (prev, next) => prev.value === next.value);
